export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6635.36590552.jpg";